define([
	'internal_util/Util',
	'model/ErrorType'
], function (
	Util,
	ErrorType
) {
	'use strict';

	/**
	 * Error class
	 */
	return function (type, message, data, dataIsMessage) {
		var _type,
			_message,
			_data = null,
			_dataIsMessage = false;

		if (Util.objectHasValue(ErrorType, type)) {
			_type = type;
		} else {
			throw new Error('invalid error type: ' + type);
		}

		if (Util.isValidString(message)) {
			_message = message;
		} else if (message instanceof window.Error) {
			_message = message.message;
		} else {
			throw new Error('invalid error message: ' + message);
		}

		if (typeof data !== 'undefined') {
			_data = data;
		}

		if (typeof dataIsMessage === 'boolean') {
			_dataIsMessage = dataIsMessage;
		}


		// public methods

		this.type = function () {
			return _type;
		};

		this.message = function () {
			return _message;
		};

		this.data = function () {
			return _data;
		};

		this.dataIsMessage = function () {
			return _dataIsMessage;
		};

		this.toObject = function () {
			return {
				type : _type,
				message : _message,
				data : _data,
				dataIsMessage : _dataIsMessage
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Error.js
// module id = 10
// module chunks = 3